import React from 'react';
import JsonViewer from '../../../JsonViewer';

/**
 * JsonViewerTab - Wrapper for JsonViewer with title and styling
 *
 * Provides consistent presentation for JSON data sections
 * within the debug tabs
 */
const JsonViewerTab = ({
  title,
  data = {},
  expanded = 8,
  theme = 'default-dark',
}) => {
  const hasData = data && Object.keys(data).length > 0;
  const hasError = data?.error;

  return (
    <div className="json-viewer-tab">
      {title && (
        <h3 className="json-viewer-tab__title">{title}</h3>
      )}
      <div className="json-viewer-tab__content">
        {hasError ? (
          <div className="json-viewer-tab__error">
            Error loading data: {data.error}
          </div>
        ) : !hasData ? (
          <div className="json-viewer-tab__empty">
            No data available
          </div>
        ) : (
          <JsonViewer
            data={data}
            expanded={expanded}
            theme={theme}
            show-data-types="false"
            show-size="false"
            expand-icon-type="square"
            show-toolbar="true"
          />
        )}
      </div>
    </div>
  );
};

export default JsonViewerTab;
